<template>
  <div class="courseDjustment-list">
    <el-table
      :data="courseDjustmentList"
      border
      style="width: 100%"
      tooltip-effect="dark"
      class="common-edit-button"
    >
      <el-table-column
        prop="applyTeacherName"
        width="150px"
        :show-overflow-tooltip="true"
        label="申请人"
      >
      </el-table-column>
      <el-table-column
        prop="courseArrangeName"
        width="150px"
        :show-overflow-tooltip="true"
        label="原课程"
      >
      </el-table-column>
      <el-table-column
        prop="exchangeTeacherName"
        width="220px"
        label="交换人"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="exchangeCourseArrangeName"
        width="220px"
        label="交换课程"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column label="调课原因" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.reason | reasonFilter }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="200px">
        <template slot-scope="scope">
          <div class="operate">
            <el-button
              type="primary"
              size="small"
              v-show="scope.row.reviewStatus == 0"
              @click="showDialog(scope.row.requestCode)"
              v-hasPermi="'sc:teacherapplyfor:aduit'"
              >审核
            </el-button>
            <!-- 撤回 -->
            <el-button
              type="danger"
              size="small"
              @click="withdraw(scope.row)"
              v-show="scope.row.reviewStatus != '3' && scope.row.createBy == user.id"
              v-hasPermi="'sc:teacherapplyfor:edit'"
              >撤回</el-button
            >
            <!-- 同意 -->
            <!-- <el-button
              v-show="scope.row.reviewStatus == 0"
              type="success"
              size="small"
              @click="updateStatus(scope.row.requestCode, 1)"
              >同意
            </el-button> -->
            <!-- 拒绝 -->
            <!-- <el-button
              v-show="scope.row.reviewStatus == 0"
              type="danger"
              size="small"
              @click="updateStatus(scope.row.requestCode, 2)"
            >
              拒绝
            </el-button> -->
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      v-if="dialogFormVisible"
      title="审核操作"
      :visible.sync="dialogFormVisible"
      center
      width="30%"
    >
      <el-form :model="form">
        <el-form-item label="调课说明">
          {{ detailData.request.reasonRemark || "无" }}
        </el-form-item>
        <el-form-item label="审核操作">
          <el-radio v-model="form.status" label="1">同意</el-radio>
          <el-radio v-model="form.status" label="2">拒绝</el-radio>
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="form.feedback"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateStatus">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    courseDjustmentList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    courseDjustmentStatus: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      detailData: null,
      dialogFormVisible: false,
      form: {
        status: "1",
        feedback: "",
      },
    };
  },
  filters: {
    reasonFilter(e) {
      return e == 1
        ? "事假"
        : e == 2
        ? "病假"
        : e == 3
        ? "婚嫁"
        : e == 4
        ? "产假"
        : e == 5
        ? "丧事"
        : "其他";
    },
  },
  methods: {
    // 撤回调课申请
    withdraw(e) {
      this.$confirm("是否撤销该调课申请?", "撤销申请", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.get(
            this.$url.schoolRequestRevocation + "?requestCode=" + e.requestCode
          )
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("撤销成功");
                // 刷新列表
                this.$emit("updateStatus", e.requestCode);
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              // console.log(err);
              // this.$message.error("撤销失败，请稍后重试");
            });
        })
        .catch(() => {});
    },
    updateStatus() {
      // console.log(this.detailData);
      let { status, feedback } = this.form;
      let { requestCode } = this.detailData.request;
      let reviewRank = this.detailData.reviewList.length + "";
      // console.log(id,reviewStatus);
      this.post(this.$url.schoolReviewRequest, {
        requestCode,
        status,
        reviewRank,
        feedback,
      })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.$emit("updateStatus", requestCode);
            this.$message.success("操作成功");
            this.dialogFormVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          this.$message.error("操作失败，请稍后重试");
        });
    },
    // 显示详情
    showDetail(id) {
      // console.log(id)
      this.$eventBus.$emit("showDetail", id);
    },
    showDialog(requestCode) {
      this.form = {
        status: "1",
        feedback: "",
      };
      this.get(
        this.$url.teacherapplyforDetail + "?requestCode=" + requestCode
      ).then((res) => {
        // console.log("调课详细信息==>", res);
        if (res.code != 200) return this.$message.error(res.msg);
        this.detailData = res.data;
        this.dialogFormVisible = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./courseDjustment-list.scss";
</style>
